module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuOBs0TtgAAACXSURBVDhPtZTRDYAgEEPZhyUcgVVcxiFci0HONtHkgGoMnh/vg6ZtIAckMwtFil+QomdLKYPlJCuPR4oE4QIqsA5qRWWIFBFYXcEdu8oOAozcmSpQDDttFgQmdcw7ap9vFjBwACr4RDOovpCTVKEnFt/xe2HskQkMcUMhMMVeGwLj3gUV7y72BQJxT8+DcMznMIsU57F0AK/NT1mioGeEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_red.png
// module id = jbqJ
// module chunks = 1